/** The HMLR title parcel resolved at a point. */
export type ParcelIdentity = { inspireId?: string | null } | null | undefined;

/** True when the analysis pin has drifted onto a DIFFERENT registered title than the site address. */
export const parcelsMismatch = (
  addressParcel: ParcelIdentity,
  pinParcel: ParcelIdentity
): boolean => {
  if (!addressParcel?.inspireId || !pinParcel?.inspireId) return false;
  return addressParcel.inspireId !== pinParcel.inspireId;
};
